module.exports = __webpack_public_path__ + "media/icons/chevron-right-34d43bda.svg";